import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/AppShell";
import Vehicles from "@/pages/tabs/Vehicles";
import Clients from "@/pages/tabs/Clients";
import Trips from "@/pages/tabs/Trips";
import AcertoFinal from "@/pages/tabs/AcertoFinal";
import Fueling from "@/pages/tabs/Fueling";
import Suppliers from "@/pages/tabs/Suppliers";
import Expenses from "@/pages/tabs/Expenses";
import Maintenance from "@/pages/tabs/Maintenance";
import Analysis from "@/pages/tabs/Analysis";
import OwnerDashboard from "@/pages/tabs/OwnerDashboard";
import Marketing from "@/pages/tabs/Marketing";
import Reports from "@/pages/tabs/Reports";
import GPS from "@/pages/tabs/GPS";
import Geofences from "@/pages/tabs/Geofences";
import Detentions from "@/pages/tabs/Detentions";
import Chat from "@/pages/tabs/Chat";
import MeuPlano from "@/pages/tabs/MeuPlano";
import Profile from "@/pages/tabs/Profile";
import BaixarApp from "@/pages/tabs/BaixarApp";

export default function CompanyDashboard() {
  return (
    <Routes>
      <Route element={<AppShell basePath="/empresa" />}>
        <Route index element={<Navigate to="analise" replace />} />
        <Route path="veiculos" element={<Vehicles />} />
        <Route path="clientes" element={<Clients />} />
        <Route path="fretes" element={<Trips />} />
        <Route path="acerto" element={<AcertoFinal />} />
        <Route path="abastecimentos" element={<Fueling />} />
        <Route path="fornecedores" element={<Suppliers />} />
        <Route path="despesas" element={<Expenses />} />
        <Route path="manutencao" element={<Maintenance />} />
        <Route path="analise" element={<Analysis />} />
        <Route path="painel-dono" element={<OwnerDashboard />} />
        <Route path="marketing" element={<Marketing />} />
        <Route path="relatorios" element={<Reports />} />
        <Route path="gps" element={<GPS />} />
        <Route path="cercas" element={<Geofences />} />
        <Route path="estadias" element={<Detentions />} />
        <Route path="chat" element={<Chat />} />
        <Route path="meu-plano" element={<MeuPlano />} />
        <Route path="perfil" element={<Profile />} />
        <Route path="baixar-app" element={<BaixarApp />} />
      </Route>
    </Routes>
  );
}
